import React from 'react';
import { FormattedMessage } from 'react-intl';

const InvoiceLink = ({ documents, invoiceClassName }) => {
  if (documents.filter(d => d.type === 'invoice' || d.type === 'invoice-correction').length <= 0) return null;

  return (
      <div key="invoice">
        {documents.filter(d => d.type === 'invoice').map((document, index) => (
          <a
            className={invoiceClassName}
            key={index}
            href={document.url}
            target="_blank"
          >
            <FormattedMessage id="OrderInfo.doc-invoice" />
          </a>
        ))}
        {documents.filter(d => d.type === 'invoice-correction').map((document, index) => (
          <a
            className={invoiceClassName}
            key={index}
            href={document.url}
            target="_blank"
          >
            <FormattedMessage id="OrderInfo.doc-invoice-correction" />
          </a>
        ))}
      </div>
    );
}

export default InvoiceLink;
